import React, {useState, useEffect} from "react";
import {AppButton} from "../../../styles/Butttons";
import Modal from "../../../containers/Modal";
import {Input, SelectStyled} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import styled from "styled-components";
import {ListUserService, UpdateUserService} from "../../../services/UserServices";
import AppLoader from "../../../components/loaders/Loader";
// import {ReactComponent as CancelIcon} from "../../../assets/icons/cancel.svg";

export default function AddAdminModal({isOpen, close, theme, save, reloadSucces}) {
   const [data, setData] = useState([]);
   const [idSelected, setSelected] = useState("");
   const [isLoading, setLoading] = useState(false);
   const [isSaving, setSaving] = useState(false);
   const [showSuccess, setShowSucces] = useState(false);

   useEffect(() => {
      if (isOpen) {
         getusers();
      }
   }, [isOpen]);

   const getusers = () => {
      ListUserService()
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;

            if (status === "error") throw new Error("Error al recuperar los usuarios");

            let newData = data.map((item) => {
               return {...item, name: `${item.userName} ${item.userLastName}`};
            });
            setData(newData);
         })
         .then(() => {
            setLoading(true);
         })
         .catch((e) => console.log(e));
   };
   const sendNew = () => {
      setSaving(true);
      let newData = data.find((user) => Number(user.idUser) === Number(idSelected));
      let toSend = {...newData, idRol: 1};

      UpdateUserService(toSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error();
         })
         .then(() => {
            setSaving(false);
         })
         .then(() => {
            reloadSucces();
         })
         .then(() => {
            setShowSucces(true);
         })
         .catch((e) => {
            console.log(e);
         });
   };

   // if (isOpen) return null;

   return (
      <>
         <Modal
            isOpen={isOpen}
            close={() => {
               close();
            }}
            theme={theme}
            showSuccess={showSuccess}
            title="Añadir administrador"
         >
            <DivModal>
               <Grid>
                  <Col large={8} offsetL={2}>
                     <SelectStyled
                        onChange={(e) => {
                           setSelected(e.target.value);
                        }}
                        defaultValue="AA"
                     >
                        <option disabled value="AA">
                           Selecciona un usuario
                        </option>
                        {React.Children.toArray(
                           data.map((item) => {
                              return <option value={item.idUser}>{item.name}</option>;
                           }),
                        )}
                     </SelectStyled>
                  </Col>
               </Grid>

               <Col large={4} offsetL={6}>
                  <AppButton onClick={sendNew}>AGREGAR</AppButton>
               </Col>
            </DivModal>
         </Modal>
         <AppLoader isVisible={isSaving} />
      </>
   );
}

const DivModal = styled.div`
   .buttonModal {
      margin-top: 2em;
   }
`;
